import { UbisoftSSO } from '../models/ubisoft';

// Grab all the env from the script tag
const tag = document.querySelector('#env-variables');
const env = (tag && JSON.parse(tag.innerHTML)) || {};

export const API = {
  baseURL: env.API_BASE_URL,
  endpoints: {
    health: 'health',
    emails: 'emails',
    enums: 'enums',
    candidates: 'candidates',
    games: 'games',
    surveys: 'surveys',
    sessions: 'sessions'
  }
};

export const UBI_SERVICES = {
  baseURL: env.SERVICES_BASE_URL,
  endpoints: {
    users: 'v3/users',
    profiles: 'v3/profiles'
  },
  appId: env.SERVICES_APP_ID
};

export const UBI_CONNECT = {
  env: env.CONNECT_BASE_URL.includes('uat') ? 'UAT' : 'PROD',
  baseURL: env.CONNECT_BASE_URL,
  nextURL: env.CONNECT_NEXT_URL,
  avatarURL: env.CONNECT_AVATAR_BASE_URL,
  endpoints: {
    login: 'login'
  },
  appId: env.SERVICES_APP_ID,
  genomeId: env.CONNECT_GENOME_ID
};

export const PLAYTEST_TYPES = {
  remote: 1,
  studio: 2,
  mobile: 3,
  vr: 4,
  toolsSoftware: 5
};

export const GOOGLE = {
  captchaId: env.GOOGLE_CAPTCHA_ID
};

export const AUTH = {} as UbisoftSSO;

export const LINKS = {
  SupportEmail: env.SUPPORT_EMAIL,
  GlobalNavigationScript: env.GLOBAL_NAVIGATION_URL,
  GlobalNavigationRedirectionURL: env.GLOBAL_NAVIGATION_REDICTION_URL
};

// This should not be confused with `process.env.NODE_ENV` as this one is runtime
// and the other one is build time
export const ENV_NAME = process.env.NODE_ENV;

export const IS_DEV = process.env.NODE_ENV !== 'production';
export const BUILD_DATE = process.env.BUILD_DATE as string;

export const SORTBY_OPTIONS = {
  Id: 1,
  Name: 2
};

export const LANGUAGES = [
  { id: 1, name: 'English', locale: 'en-ca', localizationLanguageId: 1 },
  { id: 2, name: 'Français', locale: 'fr-ca', localizationLanguageId: 2 },
  { id: 3, name: 'Deutsch', locale: 'de-de', localizationLanguageId: 3 },
  { id: 4, name: '', locale: 'zh-cn', localizationLanguageId: 4 },
  { id: 5, name: '', locale: 'ja-jp', localizationLanguageId: 5 },
  { id: 6, name: '', locale: 'fr-fr', localizationLanguageId: 2 },
  { id: 7, name: '', locale: 'it-it', localizationLanguageId: 1 },
  { id: 8, name: '', locale: 'pl-pl', localizationLanguageId: 1 },
  { id: 9, name: '', locale: 'ru-ru', localizationLanguageId: 1 },
  { id: 10, name: '', locale: 'pt-br', localizationLanguageId: 1 },
  { id: 11, name: '', locale: 'en-us', localizationLanguageId: 1 },
  { id: 12, name: '', locale: 'es-mx', localizationLanguageId: 1 },
  { id: 13, name: '', locale: 'th-th', localizationLanguageId: 1 },
  { id: 14, name: '', locale: 'en-au', localizationLanguageId: 1 },
  { id: 15, name: '', locale: 'en-sg', localizationLanguageId: 1 },
  { id: 16, name: '', locale: 'zh-tw', localizationLanguageId: 4 },
  { id: 17, name: '', locale: 'en-gb', localizationLanguageId: 1 },
  { id: 18, name: '', locale: 'es-es', localizationLanguageId: 1 },
  { id: 19, name: '', locale: 'ko-kr', localizationLanguageId: 1 }
];

export const industryInvolvements = [
  { id: 1, name: 'industryInvolvements.Studied' },
  { id: 2, name: 'industryInvolvements.Journalist' },
  { id: 3, name: 'industryInvolvements.Retail' },
  { id: 4, name: 'industryInvolvements.Competition' },
  { id: 5, name: 'industryInvolvements.MarketingUR' },
  { id: 6, name: 'industryInvolvements.Streamer' },
  { id: 7, name: 'industryInvolvements.RelatedtoUbi' },
  { id: 8, name: 'industryInvolvements.RelatedtoCompetition' },
  { id: 9, name: 'None' },
  { id: 10, name: 'industryInvolvements.WorkedatUbi' }
];

export const referrals = [
  { id: 1, name: 'referrals.Facebook' },
  { id: 2, name: 'referrals.Twitter' },
  { id: 3, name: 'referrals.Instagram' },
  { id: 4, name: 'referrals.LinkedIn' },
  { id: 5, name: 'referrals.OtherSocialMedia' },
  { id: 6, name: 'referrals.Advertisement' },
  { id: 7, name: 'referrals.UbisoftWebsite' },
  { id: 8, name: 'referrals.UbisoftEmail' },
  { id: 9, name: 'referrals.UbisoftEmployee' },
  { id: 10, name: 'referrals.FriendorRelative' },
  { id: 11, name: 'referrals.Event' },
  { id: 12, name: 'referrals.GamePlaytesterCrew' },
  { id: 13, name: 'referrals.Other' }
];

export const languages = [
  { id: 1, name: 'languages.English' },
  { id: 2, name: 'languages.French' },
  { id: 3, name: 'languages.German' },
  { id: 4, name: 'languages.Chinese' },
  { id: 5, name: 'languages.Japanese' }
];

export const playtestTypes = [
  { id: 1, name: 'playtestTypes.Remote' },
  { id: 2, name: 'playtestTypes.Studio' },
  { id: 3, name: 'playtestTypes.Mobile' },
  { id: 4, name: 'playtestTypes.VR' },
  { id: 5, name: 'playtestTypes.ToolsSoftware' }
];

export const canProvinces = [
  { id: 53, name: 'canProvinces.Alberta' },
  { id: 54, name: 'canProvinces.BritishColumbia' },
  { id: 55, name: 'canProvinces.Manitoba' },
  { id: 56, name: 'canProvinces.NewBrunswick' },
  { id: 57, name: 'canProvinces.Newfoundland' },
  { id: 58, name: 'canProvinces.NorthwestTerritories' },
  { id: 59, name: 'canProvinces.NovaScotia' },
  { id: 60, name: 'canProvinces.Nunavut' },
  { id: 61, name: 'canProvinces.Ontario' },
  { id: 62, name: 'canProvinces.PrinceEdwardIsland' },
  { id: 63, name: 'canProvinces.Quebec' },
  { id: 64, name: 'canProvinces.Saskatchewan' },
  { id: 65, name: 'canProvinces.YukonTerritory' }
];

export const peripherals = [
  { id: 1, name: 'None' },
  { id: 2, name: 'peripherals.PS' },
  { id: 3, name: 'peripherals.Xbox' },
  { id: 4, name: 'peripherals.HeadphonesWithMicrophone' },
  { id: 5, name: 'peripherals.Webcam' },
  { id: 6, name: 'peripherals.EyeTracker' },
  { id: 7, name: 'peripherals.VideoCaptureCard' },
  { id: 8, name: 'peripherals.VRDevice' }
];

export const internetSpeeds = [
  { id: 1, name: 'internetSpeeds.0-9Mbps' },
  { id: 2, name: 'internetSpeeds.10-20Mbps' },
  { id: 3, name: 'internetSpeeds.21-40Mbps' },
  { id: 4, name: 'internetSpeeds.41-100Mbps' },
  { id: 5, name: 'internetSpeeds.>100Mbps' }
];

export const operatingSystems = [
  { id: 1, name: 'operatingSystems.Windows10', groupId: 1, index: 2 },
  { id: 2, name: 'operatingSystems.Windows8orOlder', groupId: 1, index: 3 },
  { id: 3, name: 'operatingSystems.MacOS' },
  { id: 4, name: 'operatingSystems.Linux' },
  { id: 5, name: 'operatingSystems.ChromeOS' },
  { id: 6, name: 'operatingSystems.Windows11', groupId: 1, index: 1 }
];

export const specifications = [
  { id: 1, name: 'specifications.Low' },
  { id: 2, name: 'specifications.Average' },
  { id: 3, name: 'specifications.High' }
];

export const mobilePlayFrequencies = [
  { id: 1, name: 'playFrequencies.MultipleTimesADay' },
  { id: 2, name: 'playFrequencies.OnceADay' },
  { id: 3, name: 'playFrequencies.SeveralTimesPerWeek' },
  { id: 4, name: 'playFrequencies.OncePerWeek' },
  { id: 5, name: 'playFrequencies.SeveralTimesPerMonth' },
  { id: 6, name: 'playFrequencies.OncePerMonth' }
];

export const mobileSessionPlaytimes = [
  { id: 1, name: 'sessionPlaytimes.3+hours' },
  { id: 2, name: 'sessionPlaytimes.1-3hours' },
  { id: 3, name: 'sessionPlaytimes.30minutes-1Hour' },
  { id: 4, name: 'sessionPlaytimes.10-30Minutes' },
  { id: 5, name: 'sessionPlaytimes.LessThan10minutes' }
];

export const mobilePlayLocations = [
  { id: 1, name: 'playLocations.Home' },
  { id: 2, name: 'playLocations.Commute' },
  { id: 3, name: 'playLocations.WorkOrSchool' },
  { id: 4, name: 'playLocations.Bathroom' },
  { id: 5, name: 'playLocations.Other' }
];

export const mobileGamingGenres = [
  { id: 1, name: 'gamingGenres.N/A' },
  { id: 2, name: 'gamingGenres.Strategy' },
  { id: 3, name: 'gamingGenres.Management' },
  { id: 4, name: 'gamingGenres.Runner' },
  { id: 5, name: 'gamingGenres.Arcade' },
  { id: 6, name: 'gamingGenres.Adventure&RPG' },
  { id: 7, name: 'gamingGenres.Shooters' },
  { id: 8, name: 'gamingGenres.HiddenObject' },
  { id: 9, name: 'gamingGenres.Puzzle' },
  { id: 10, name: 'gamingGenres.Racing' },
  { id: 11, name: 'gamingGenres.Multiplayer' },
  { id: 12, name: 'gamingGenres.CardGames' },
  { id: 13, name: 'gamingGenres.Location-based' },
  { id: 14, name: 'gamingGenres.BattleRoyale' },
  { id: 15, name: 'gamingGenres.AutoChess' },
  { id: 16, name: 'gamingGenres.BrainGames' },
  { id: 17, name: 'gamingGenres.CasinoGames' },
  { id: 18, name: 'gamingGenres.CollectibleBattleGames' },
  { id: 19, name: 'gamingGenres.LifeSimulationGames' },
  { id: 20, name: 'gamingGenres.MMORPG' },
  { id: 21, name: 'gamingGenres.MOBA' },
  { id: 22, name: 'gamingGenres.NarrativeGames' },
  { id: 23, name: 'gamingGenres.SportGames' },
  { id: 24, name: 'gamingGenres.SandboxGames' },
  { id: 25, name: 'None' }
];

export const mobileDevices = [
  { id: 1, name: 'devices.AndroidPhone' },
  { id: 2, name: 'devices.AndroidTablet' },
  { id: 3, name: 'devices.iOSPhone' },
  { id: 4, name: 'devices.iOSTablet' },
  { id: 5, name: 'devices.Other' },
  { id: 6, name: 'None' }
];

export const mobilePeripherals = [
  { id: 1, name: 'None' },
  { id: 2, name: 'peripherals.Controller' },
  { id: 3, name: 'peripherals.Keyboard' },
  { id: 4, name: 'peripherals.Mouse' },
  { id: 5, name: 'peripherals.Other' }
];

export const controllers = [
  { id: 1, name: 'controllers.PlayStation3', groupId: 1, index: 3 },
  { id: 2, name: 'controllers.PlayStation4', groupId: 1, index: 2 },
  { id: 3, name: 'controllers.Xbox360', groupId: 2, index: 4 },
  { id: 4, name: 'controllers.XboxOne', groupId: 2, index: 3 },
  { id: 5, name: 'controllers.Switch' },
  { id: 6, name: 'controllers.MouseAndKeyboard' },
  { id: 7, name: 'controllers.Mobile' },
  {
    id: 8,
    name: 'controllers.XboxAccessibilityController',
    groupId: 2,
    index: 2
  },
  { id: 9, name: 'controllers.EyeTracker' },
  { id: 10, name: 'controllers.Stadia' },
  { id: 11, name: 'None' },
  { id: 12, name: 'controllers.PlayStation5', groupId: 1, index: 1 },
  { id: 13, name: 'controllers.XboxSeriesX|S', groupId: 2, index: 1 }
];

export const gamingGenres = [
  { id: 1, name: 'gamingGenres.ActionAdventure' },
  { id: 2, name: 'gamingGenres.Adventure' },
  { id: 3, name: 'gamingGenres.CardGame' },
  { id: 4, name: 'gamingGenres.Fighting' },
  { id: 5, name: 'gamingGenres.Fitness/Dance' },
  { id: 6, name: 'gamingGenres.HackAndSlash' },
  { id: 7, name: 'gamingGenres.Indie' },
  { id: 8, name: 'gamingGenres.MMO' },
  { id: 9, name: 'gamingGenres.MOBA' },
  { id: 10, name: 'gamingGenres.Music/Rhythm' },
  { id: 11, name: 'gamingGenres.Platformer' },
  { id: 12, name: 'gamingGenres.Puzzle' },
  { id: 13, name: 'gamingGenres.Racing' },
  { id: 14, name: 'gamingGenres.RPG' },
  { id: 15, name: 'gamingGenres.Shooter' },
  { id: 16, name: 'gamingGenres.ShootEmup' },
  { id: 17, name: 'gamingGenres.Sports' },
  { id: 18, name: 'gamingGenres.Simulation' },
  { id: 19, name: 'gamingGenres.Stealth' },
  { id: 20, name: 'gamingGenres.Strategy' },
  { id: 21, name: 'gamingGenres.Survival/Horror' },
  { id: 22, name: 'gamingGenres.BattleRoyale' },
  { id: 23, name: 'None' },
  { id: 24, name: 'gamingGenres.Metroidvania' }
];

export const weeklyPlaytimes = [
  { id: 1, name: 'weeklyPlaytimes.0to5hours' },
  { id: 2, name: 'weeklyPlaytimes.6to10hours' },
  { id: 3, name: 'weeklyPlaytimes.11to15hours' },
  { id: 4, name: 'weeklyPlaytimes.16to20hours' },
  { id: 5, name: 'weeklyPlaytimes.21to30hours' },
  { id: 6, name: 'weeklyPlaytimes.31to40hours' },
  { id: 7, name: 'weeklyPlaytimes.41to60hours' },
  { id: 8, name: 'weeklyPlaytimes.60+hours' }
];

export const difficulties = [
  { id: 1, name: 'difficulties.Easy' },
  { id: 2, name: 'difficulties.Normal' },
  { id: 3, name: 'difficulties.Hard' },
  { id: 4, name: 'difficulties.Nightmare' }
];

export const dlcTypes = [
  { id: 1, name: 'dlcTypes.Characters' },
  { id: 2, name: 'dlcTypes.Cosmetics' },
  { id: 3, name: 'dlcTypes.Item' },
  { id: 4, name: 'dlcTypes.AdditionalGameContent' },
  { id: 5, name: 'dlcTypes.SeasonsPass' },
  { id: 6, name: 'dlcTypes.Lootboxes' },
  { id: 7, name: 'dlcTypes.BoosterPacks' },
  { id: 8, name: 'dlcTypes.BattlePass' },
  { id: 9, name: 'dlcTypes.MoneyPacks' },
  { id: 10, name: 'None' }
];

export const socialHabits = [
  { id: 1, name: 'socialHabits.N/A' },
  { id: 2, name: 'socialHabits.WithStrangers' },
  { id: 3, name: 'socialHabits.WithFriends' }
];

export const PROFIL_TABS = [
  {
    pathname: 'personalinformation'
  },
  {
    pathname: 'playtests'
  },
  {
    pathname: 'gaminghabits'
  },
  {
    pathname: 'gamesplayed'
  }
];

export const IGDB = {
  baseURL: env.IGDB_IMAGE_BASE_URL
};

export const UBISOFT_ACCOUNT = {
  baseURL: env.UBISOFT_ACCOUNT_URL
};

export const NOT_AVAILABLE_VALUE = 'not available';

export const gameExperiences = [
  { id: 0, name: 'gameExperiences.DidNotPlay' },
  { id: 1, name: 'gameExperiences.0to5hours' },
  { id: 2, name: 'gameExperiences.6to10hours' },
  { id: 3, name: 'gameExperiences.11to15hours' },
  { id: 4, name: 'gameExperiences.16to20hours' },
  { id: 5, name: 'gameExperiences.21to30hours' },
  { id: 6, name: 'gameExperiences.31to40hours' },
  { id: 7, name: 'gameExperiences.41to60hours' },
  { id: 8, name: 'gameExperiences.61to100hours' },
  { id: 9, name: 'gameExperiences.101to200hours' },
  { id: 10, name: 'gameExperiences.201to500hours' },
  { id: 11, name: 'gameExperiences.500+hours' }
];

export const accessibilities = [
  { id: 1, name: 'accessibilities.Na' },
  { id: 2, name: 'accessibilities.Physical' },
  { id: 3, name: 'accessibilities.Cognitive' },
  { id: 4, name: 'accessibilities.Intellectual' },
  { id: 5, name: 'accessibilities.Visual' },
  { id: 6, name: 'accessibilities.Auditory' },
  { id: 7, name: 'accessibilities.Other' },
  { id: 8, name: 'None' }
];

export const toolsSoftwares = [
  { id: 1, name: 'None' },
  { id: 2, name: 'toolsSoftwares.UbisoftConnect' },
  { id: 3, name: 'toolsSoftwares.R6Marketplate' }
];

export const countries = [
  { id: 1, name: 'countries.Canada' },
  { id: 2, name: 'countries.France' },
  { id: 3, name: 'countries.UnitedStates' },
  { id: 4, name: 'countries.UnitedKingdom' },
  { id: 5, name: 'countries.Germany' },
  { id: 6, name: 'countries.Sweden' },
  { id: 7, name: 'countries.Finland' },
  { id: 8, name: 'countries.Singapore' },
  { id: 9, name: 'countries.Romania' },
  { id: 10, name: 'countries.China' },
  { id: 11, name: 'countries.Japan' }
];

export const CUSTOM_QUESTION_TYPE = {
  BINARY: 1,
  SINGLE: 2,
  MULTIPLE: 3,
  OPEN_ENDED: 4
};

export const QUESTION_CHOICE_LIMIT_TYPE = {
  NO_LIMIT: 1,
  EQUAL: 2,
  LESS_OR_EQUAL: 3
};

export const CANADA = 'CAN';
export const USA = 'USA';
export const USER_GAME_EXP_LAST_UPDATED_THRESHOLD = 6; // months

export const COUNTRIESATTOP = [
  { countryCode: CANADA, name: 'Canada', index: 1 },
  { countryCode: USA, name: 'United States', index: 2 },
  { countryCode: 'FRA', name: 'France', index: 3 }
];

export const FIRST_QUESTION_ID = 'first-q';
export const ROUTE_PROFILE_NAME = 'profile';

// Supported key in keyboard for click action
export const ENTER_KEY_CODE = 13;

export const REG_EXP = {
  postalCode: /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i,
  phone:
    /((?:\+|00)[17](?: |-)?|(?:\+|00)[1-9]\d{0,2}(?: |-)?|(?:\+|00)1-\d{3}(?: |-)?)?(0\d|\(\d{3}\)|[1-9]{0,3})(?:((?: |-)\d{2}){4}|((?:\d{2}){4})|((?: |-)\d{3}(?: |-)\d{4})|(\d{7}))$/
};
